module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAAAXNSR0IArs4c6QAAAMpJREFUKBWV0bEOQTEUBuD/tOIB7gswWg1isLLZLEQ8mMEosdiMVoNciUfAC3gAUdVzbi7uddvSpOnyn6+nPUBkjdNzm3ckBgoFBDDYSkajv+o0j768F3ojNsmK6YoAVgkVEMJNIIs64Me+oDKioUYMGTzWCGAFqApZdhsbhqb7yzCEvaAQwhCvECbQL0hG+TGaHE4te6cd4KbjPpb/JH9OXlw+y51RzfaUNTT7B2GUL5IhyERtwoZSihZEmCvSg1gnn51xlmuk1hlPVA2A6ZMjKCQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/mytronics/path.png
// module id = o6aK
// module chunks = 0